import { useMutation, useQueryClient } from "@tanstack/react-query";

import { HTTP_NOT_FOUND, HttpError, removeChecklistItem } from "./api";

// Аргументы DELETE: репозиторий (нужен только для инвалидации — адресация
// самого запроса идёт по `itemId`) и `id` удаляемого пункта.
export interface RemoveChecklistItemArgs {
  readonly repoFullName: string;
  readonly itemId: string;
}

// DELETE пункта по `id`. На успех инвалидируем список пары — строка
// исчезнет из таблицы. Инвалидация по смысловому префиксу
// (repo_full_name, тот же что у useChecklist) матчит запись любого
// org-скоупа (см. `src/query/scope.ts`).
//
// Swallow-404: backend отдаёт 404, если пункта уже нет (например, удалён
// в другой вкладке). Для UI «уже отсутствует» = «удалено»: ловим 404 и
// трактуем как успех, остальные коды пробрасываем как ошибку мутации.
export function useRemoveChecklistItem(): ReturnType<
  typeof useMutation<void, Error, RemoveChecklistItemArgs>
> {
  const queryClient = useQueryClient();
  return useMutation<void, Error, RemoveChecklistItemArgs>({
    mutationFn: async ({ itemId }) => {
      try {
        await removeChecklistItem(itemId);
      } catch (error) {
        if (error instanceof HttpError && error.status === HTTP_NOT_FOUND) {
          return;
        }
        throw error;
      }
    },
    onSuccess: (_void, variables) => {
      void queryClient.invalidateQueries({
        queryKey: ["reviewerChecklist", variables.repoFullName.trim()],
      });
    },
  });
}
